const clearCanvas = (canvasElement) => {
	canvasElement.getContext('2d').clearRect(0, 0, canvasElement.width, canvasElement.height);
};
export default clearCanvas;
